import queryString from 'query-string'
import { useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { saveMagicLinkToken } from '../../use-cases/magicLinkToken'

export function useSaveMagicLinkToken() {
  const location = useLocation()
  const history = useHistory()
  const parsed = useMemo(() => queryString.parse(location.search), [location.search])

  useEffect(() => {
    if (typeof parsed.token === 'string') {
      const urlToken = parsed.token

      saveMagicLinkToken(urlToken)

      // The token is saved, so we can remove it from the URL
      history.replace({
        search: queryString.stringify({
          ...parsed,
          token: undefined,
        }),
      })
    }
  }, [parsed, history])
}
